import { UtilityRunRequest } from "./utility-run-request";
import { UtilityRunResponse } from "./utility-run-response";
import { v4 as uuidv4 } from "uuid";

export class UtilityRun {
    constructor(utilityId: string, userId: string, whenBegin: Date, whenEnd: Date, 
        timeout: number, importance: string, description: string, request: UtilityRunRequest) {
            this.utilityId = utilityId;
            this.userId = userId;
            this.whenBegin = whenBegin;
            this.whenEnd = whenEnd;
            this.timeout = timeout;
            this.importance = importance;
            this.description = description;
            this.request = request;
            this.response = null;
            this.id = uuidv4();
    }

    utilityId: string;
    userId: string;
    whenBegin: Date;
    whenEnd: Date;
    timeout: number;
    importance: string;
    description: string;
    request: UtilityRunRequest;
    response: UtilityRunResponse;
    id: string
}